const CardWrapper = ({ children, className, index }) => {
  return <div className={`cardWrapper ${className}`}>{children}</div>;
};

export default CardWrapper;
